import React, { useEffect, useRef } from 'react';

export default function TranscriptFeed({ transcript }) {
  const transcriptEndRef = useRef(null);

  // Auto-scroll transcript window on update
  useEffect(() => {
    transcriptEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [transcript]);

  return (
    <>
      <h3>Shared Transcript & AI Agent View</h3>
      <div style={{ border: '1px solid #ccc', height: '420px', overflowY: 'scroll', padding: '15px', background: '#fafafa', borderRadius: '6px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {transcript.map((item, index) => {
          const isAI = item.speaker.includes('AI') || item.speaker === 'Atlas';
          
          return (
            <div key={index} style={{ padding: '8px 12px', background: isAI ? '#e8f4fd' : '#fff', border: '1px solid #e0e0e0', borderRadius: '4px' }}>
              <span style={{ fontWeight: 'bold', color: isAI ? '#0275d8' : '#333' }}>
                [{item.speaker}] ({item.timestamp}):
              </span>{' '}
              <span style={{ color: item.isThinking ? '#888' : '#222', fontStyle: item.isThinking ? 'italic' : 'normal' }}>
                {item.message}
              </span>
            </div>
          );
        })}
        <div ref={transcriptEndRef} />
      </div>
    </>
  );
}